export const blockIconsFileUpload = (
	<span className='material-symbols-outlined'>upload</span>
);
